import React from 'react'
import ShimmerScreen from '../components/Layouts/ShimmerScreen'

const GroupWorkshopTrainerShimmer = () => {

  return (
    <div>
        <div className="trainer-list-box d-flex ">
                    <div className="listing-trainer">
                      {[1,2,3,4].map(() => (
                        <div
                          className="d-flex listviewtrainer"                                                      
                        //   onClick={() => handleRowClick(trainer)}
                        >
                          <div className="cehbox">                            
                            <ShimmerScreen
                            case='rect'
                            width='3rem'
                            height="3rem"
                            />
                          </div>
                          <div className="coursebox-traienr">
                            <div className="trianerimg">
                            <ShimmerScreen
                            case='rect'
                            width='4rem'
                            height="4rem"
                            />
                            </div>
                            <div className="trainerinfo">
                              <div className="d-flex align-items-center gap-2">
                                <div className="nametraine">
                                <ShimmerScreen
                                  case='rect'
                                  width='4rem'
                                  height="2rem"
                                />
                                </div>
                                <div className="pills">
                                <ShimmerScreen
                                  case='rect'
                                  width='3.5rem'
                                  height="1.5rem"
                                />
                                </div>
                              </div>
                              <div className="infotrainer">
                                <span className="trainerico">
                                  {/* Experience{" "} */}
                                  {/* <strong>{trainer.experience} Years</strong> */}
                                  <ShimmerScreen
                                  case='rect'
                                  width='4rem'
                                  height="1rem"
                                />
                                </span>
                                {/* <span className="trainerico">
                                  Skills{" "}
                                  <strong>
                                    {trainer?.skills?.map((skill, index) => ( */}
                                      <ShimmerScreen
                                      case='rect'
                                      width='25rem'
                                      height="1rem"
                                    />
                                    {/* ))}
                                  </strong> */}
                                {/* </span> */}
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>

                    {/* Right Side card */}
                    <div className="coach-box">
                      <div className="above-info">
                        <div className="img-box-caoch">
                        <ShimmerScreen
                                  case='rect'
                                  width='19rem'
                                  height="9rem"
                                />
                          <div className="overlay-box-ino d-flex justify-content-between">
                            <div className="infobox">
                              {/* {trainerDetails.title} */}
                              <ShimmerScreen
                                  case='rect'
                                  width='6rem'
                                  height="1.5rem"
                                />
                            </div>
                            <div className="infobox">                              
                              {/* Exp {trainerDetails.experience}yrs */}
                              <ShimmerScreen
                                  case='rect'
                                  width='4rem'
                                  height="1rem"
                                />
                            </div>
                          </div>
                        </div>
                        <div className="caoch-info">
                          <h4 className="coach-tiele">
                            {/* {trainerDetails.display_name} */}
                            <ShimmerScreen
                                  case='rect'
                                  width='4rem'
                                  height="2rem"
                                />
                          </h4>
                          <div className="coach-desx">
                            {/* <p>{trainerDetails.description}</p> */}
                            <ShimmerScreen
                                  case='rect'
                                  width='18rem'
                                  height="7rem"
                                />

                            {/* <span className="readmore">
                                                                                  Read more...
                                                                                </span> */}
                          </div>
                          <div className="key-skills-coach">
                            <p>
                              {/* <strong>Key Skills</strong> */}
                              <ShimmerScreen 
                                    case='rect'
                                    width='4rem'
                                    height="1.2rem"
                                    />   
                            </p>                            
                                <p >
                                  {/* {skill.name} */}
                                  {[1,2].map(()=>(
                                    <>
                                    <ShimmerScreen 
                                    case='rect'
                                    width='14rem'
                                    height="1.2rem"
                                    />
                                    <br/>
                                    </>   
                                  ))}
                                                                      
                                  {/* Digital marketing, SEO, SMO, Market research */}
                                </p>                              
                          </div>

                          <div className="socliwra">
                            <p>
                            <ShimmerScreen
                                  case='rect'
                                  width='6rem'
                                  height="1.5rem"
                                />
                                <br/>
                              {/* <strong>Portfolio/Profile Link</strong> */}
                              <ShimmerScreen 
                                case='rect'
                                width='17rem'
                                height="1.2rem"
                                />
                            </p>
                            <div className="socililink-caoc">
                              
                                <div
                                  className="socl-icon cursor-pointer"                                  
                                >
                                  <ShimmerScreen 
                                case='rect'
                                width='3rem'
                                height="3rem"
                                />
                                </div>                              

                              
                                <div
                                  className="socl-icon cursor-pointer"                                  
                                >
                                  <ShimmerScreen 
                                case='rect'
                                width='3rem'
                                height="3rem"
                                />
                                </div>                              
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
      
    </div>
  )
}

export default GroupWorkshopTrainerShimmer
